import Cookie from 'cookie-universal';

class WebStore {
  cookies = Cookie();
  setCookies = cookies => {
    this.cookies = cookies;
  };
  delete = async key => this.cookies.remove(key);
  get = async key => this.cookies.get(key);
  save = async (key, value, expires) => this.cookies.set(key, value, {
      expires,
      httpOnly: false,
      path: '/',
      secure: true,
      sameSite: 'lax',
    });
}

export default new WebStore();
